import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import styled from "styled-components"
import { useTranslation } from 'react-i18next';
import { jwtDecode } from "jwt-decode";

const Contact = () => {
  const { t } = useTranslation();
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
  const [status, setStatus] = useState("")
  const [form, setForm] = useState({
    subject: "",
    message: "",
  });
  
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
  
    const payload = {
      ...form,
      name: `${firstName} ${lastName}`,
      email,
      phone, 
    };

    try {
      const response = await fetch(`${API_URL}send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const msg = await response.text();
      if (msg) {
        setStatus(t("contact.success"));
      }
    } catch (err) {
      console.error(err);
      setStatus("❌");
    }
  };

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    let userId;
    try {
      const decoded = jwtDecode(token);
      userId = decoded.userId;
    } catch (err) {
      console.error("Invalid token:", err);
      return;
    }

    // fetch user account
    fetch(`${API_URL}account/${userId}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch account");
        return res.json();
      })
      .then((data) => {
        setFirstName(data.firstName || "");
        setLastName(data.lastName   || "");
        setEmail(data.email         || "");
        setPhone(data.phoneNumber   || "");
      })
      .catch((err) => console.error("Failed to load customer data", err));
  }, [API_URL]);

  return (
    <EVERYTHING>
      <Header />
      <PageWrapper>
        <H2>{t('contact.title')}</H2>
        <FormWrapper onSubmit={handleSubmit}>
          <Input name="name" placeholder={t('contact.firstName')} value={firstName} onChange={(e) => setFirstName(e.target.value)} required/>
          <Input name="name" placeholder={t('contact.lastName')} value={lastName} onChange={(e) => setLastName(e.target.value)} required/>
          <Input name="Phone Number" type="phone" placeholder={t('contact.phone')} value={phone} onChange={(e) => setPhone(e.target.value)} required/>
          <Input name="email" type="email" placeholder={t('contact.email')} value={email} onChange={(e) => setEmail(e.target.value)} required/>
          <Input name="subject" placeholder={t('contact.subject')} value={form.subject} onChange={handleChange} required/>
          <TextArea name="message" placeholder={t('contact.message')} value={form.message} onChange={handleChange} required/>
          <SubmitButton type="submit">{t('contact.send')}</SubmitButton>
        </FormWrapper>
        <StatusMessage>{status}</StatusMessage>
      </PageWrapper>
      <Footer />
    </EVERYTHING>
  );
};

export default Contact;

const H2 = styled.h2`
text-align: center;
font-family: 'Great Vibes', cursive;
  font-size: 55px;
  background-color: rgba(186,204,171,1);
  border-radius: 10px;
  padding-top: 15px;
  box-shadow: 5px 4px 0px rgba(148,163,135,1);
  width: 50%;
  margin: 0 auto 20px auto;
  cursor: default;

  @media (max-width: 480px) {
    width: 90%;
    font-size: 40px;
  }
`
const PageWrapper = styled.div`
  padding: 60px 20px;
  max-width: 960px;
  margin: 70px auto;
  background-color: #ffffff;
  box-shadow: 1px 4px 12px gray;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 40px 15px;
  }
`;
const EVERYTHING = styled.div`
background:linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
`

const FormWrapper = styled.form`
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid green;
`;

const TextArea = styled.textarea`
  font-family: 'Arial';
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid green;
  resize: vertical;
  min-height: 100px;
`; 

const SubmitButton = styled.button`
  padding: 0.75rem;
  background-color:rgba(148,163,135,1);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    background-color:rgba(186,204,171,1);
  }
`;

const StatusMessage = styled.p`
  margin-top: 1rem;
  font-style: italic;
  color: #333;
  text-align: center;
`;